import React, { useState } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';

import { userLogOut } from '../../shared/actions/user';

const logOut = () => dispatch => {
    dispatch(userLogOut());
    return Promise.resolve();
}

const ControlPanel = (props) => {
    function handleLogOut() {
        props.dispatch(logOut()).then(() => window.location.reload(false));
    }

    return (
        <div className="ac-manager">
            <h2>Control Panel</h2>
            <Link to="/app/manage/auth-requests">Issue Auth Requests</Link>
            <Link to="/app/501f/search">Manage 501F Vendors</Link>
            <Link to="/app/d5/search">Manage D5 Vendors</Link>

            <button onClick={(e) => {handleLogOut()}}>Log Out</button>
        </div>);
};

function mapStateToProps(state){
    return {user: state.user};
}

export default connect(mapStateToProps)(ControlPanel);